import { Component, HostListener, inject } from '@angular/core';
import {ApplicationService} from '../../service/application.service';
import {CookieBannerComponent} from './cookie.banner.component';
import {CookieService} from '../../service/cookie.service';
import {NgClass} from '@angular/common';

@Component({
	selector: 'cookie-banner-modal',
	templateUrl: 'cookie.banner.modal.component.html',
	styleUrls: ['cookie.banner.modal.component.scss'],
	standalone: true,
	imports: [NgClass]
})
export class CookieBannerModalComponent {
	protected applicationService = inject(ApplicationService);
	protected cookieService = inject(CookieService);


	modalOpen: boolean = true;
	marketingCookies: boolean = false;
	analyticsCookies: boolean = false;

	constructor() {
		const applicationService = this.applicationService;
		const cookieService = this.cookieService;

		this.applicationService = applicationService;
		this.cookieService = cookieService;
		this.marketingCookies = this.isMarketingCookies;
		this.analyticsCookies = this.isAnalyticsCookies;
	}

	get isMarketingCookies(): boolean {
		return this.cookieService.getCookieByName(CookieBannerComponent.ACCEPT_MARKETING_COOKIES_NAME) === 'true';
	}

	get isAnalyticsCookies(): boolean {
		return this.cookieService.getCookieByName(CookieBannerComponent.ACCEPT_ANALYTICS_COOKIES_NAME) === 'true';
	}

	acceptSelectedCookies(): void {
		this.agreeToEssentialCookies();
		this.setAnalyticsCookies();
		this.setMarketingCookies();
		this.close();
	}

	toggleMarketingCookies(): void {
		this.marketingCookies = !this.marketingCookies;
	}

	toggleAnalyticsCookies(): void {
		this.analyticsCookies = !this.analyticsCookies;
	}

	@HostListener('document:click', ['$event'])
	handleClick(event) {
		const clickedComponent = event.target;
		if (clickedComponent.className === 'modal-background') {
			this.close();
		}
	}

	/**
	 * Close the modal
	 */
	close(): void {
		this.modalOpen = false;
		setTimeout(() => this.applicationService.closeCustomizeCookiePopup(), 500);
	}

	private agreeToEssentialCookies(): void {
		this.cookieService.setCookieByName(CookieBannerComponent.ACCEPTED_COOKIES, true);
		this.cookieService.setCookieByName(CookieBannerComponent.ACCEPT_ESSENTIAL_COOKIES_NAME, true);
	}

	/**
	 * Sets the statistical cookie acceptance.
	 * This will allow for instance analytics cookies.
	 */

	private setAnalyticsCookies(): void {
		this.cookieService.setCookieByName(CookieBannerComponent.ACCEPT_ANALYTICS_COOKIES_NAME, this.analyticsCookies);
	}

	/**
	 * Sets the marketing cookie acceptance.
	 * This will allow for example setting a cookie for adwords.
	 */
	private setMarketingCookies(): void {
		this.cookieService.setCookieByName(CookieBannerComponent.ACCEPT_MARKETING_COOKIES_NAME, this.marketingCookies);
	}
}
